import { AppRole, AppRoleType } from './roles.constants';
import { PermissionType } from './permissions.constants';

/**
 * Map each app role to the set of permissions it has.
 * Administrator gets all via AuthService.isAdmin() and is not listed here.
 */
export const ROLE_PERMISSIONS: Record<AppRoleType, PermissionType[]> = {
  [AppRole.FRONT_DESK]: [
    'user.profile',
    'user.logout',
    'master.any',
    'patient.search',
    'patient.register',
    'patient.edit',
    'patient.insurance_plan',
    'patient.documents',
    'scheduler.appointment_calendar',
    'scheduler.checkin_checkout',
    'scheduler.quick_schedule',
    'scheduler.wait_list',
    'utility.location_provider_lookup',
    'utility.front_desk_shortcuts',
    'utility.label_receipt_printing',
    'reports.checkin_summary',
    'reports.noshow_cancellation',
    'reports.daily_copay_collection',
    'reports.procedure_day_sheet',
    'reports.followup',
    'daily_roster.view',
    'batch.any',
  ],
  [AppRole.NURSE]: [
    'user.profile',
    'user.logout',
    'patient.today_clinical_worklist',
    'patient.chart_limited',
    'scheduler.clinical_schedule',
    'utility.nursing_tools',
    'utility.task_list',
    'reports.followup',
    'reports.procedure_day_sheet',
    'reports.patient_didnot_showup',
    'patient_detail.diagnosis_chart',
    'daily_roster.view',
    'master.any',
  ],
  [AppRole.DOCTOR]: [
    'user.profile',
    'user.logout',
    'patient.doctor_worklist',
    'patient.search',
    'patient.chart_full',
    'scheduler.provider_schedule',
    'scheduler.overbook_squeeze',
    'utility.clinical_templates',
    'utility.prescription_tools',
    'reports.followup',
    'reports.procedure_day_sheet',
    'reports.patient_didnot_showup',
    'patient_detail.diagnosis_chart',
    'patient_detail.full_clinical',
    'daily_roster.view',
    'batch.any',
    'master.doctor_menu',
  ],
  [AppRole.BILLER]: [
    'user.profile',
    'user.logout',
    'daily_roster.view',
    'patient.search',
    'patient.financial_summary',
    'patient.charge_history',
    'scheduler.appointment_calendar',
    'scheduler.billing_view',
    'utility.batch_management',
    'utility.code_fee_tools',
    'reports.checkin_summary',
    'reports.daily_copay_collection',
    'reports.followup',
    'reports.procedure_day_sheet',
    'reports.patient_didnot_showup',
    'batch.any',
    'patient_detail.financial_only',
    'patient_detail.admin_status_view',
    'follow_up.view',
    'master.any',
  ],
  [AppRole.ADMINISTRATOR]: [], // Handled in service: admin gets all
};
